/* eslint-disable react/destructuring-assignment */
import React, { FC, useContext, useMemo } from 'react'

import { ProductContext } from '@Components/Product/Context'
import SliderProvider from '@Components/Product/Slider'
import { getGalleryAssets } from '@Domains/Product/Features/Display/GalleryAssets'
import ProductSliders from '@Domains/Product/Features/Display/ProductSliders/ProductSliders'
import GiftCardInfoV2 from '@Domains/Product/Features/GiftCard/GiftCardInfo/GiftCardInfo'

import styles from './GiftCardDisplay.module.scss'

const GiftCardDisplayV2: FC = () => {
  const product = useContext(ProductContext)
  const assets = useMemo(() => getGalleryAssets(product), [product])

  if (!product) {
    return <>404</>
  }
  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <div className={styles.layout}>
          <div className={styles.slider}>
            <SliderProvider slides={assets}>
              <ProductSliders />
            </SliderProvider>
          </div>
          <div className={styles.info}>
            <GiftCardInfoV2 />
          </div>
        </div>
      </div>
    </div>
  )
}
export default GiftCardDisplayV2

